module.exports = __webpack_public_path__ + "static/img/villamilibrela.d0f2a19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/villamilibrela.png
// module id = hoFB
// module chunks = 0